import { Language } from '@summer-health/types/locale';

export type LocaleData<T> = Partial<Record<Language, Record<string, T>>>;

export function getContent<T>(
  data: LocaleData<T>,
  key: string,
  language: Language = Language.English,
): T | undefined {
  return data[language]?.[key] ?? data[Language.English]?.[key];
}

export function getAllContent<T>(
  data: LocaleData<T>,
  language: Language = Language.English,
): Record<string, T> {
  return {
    ...(data[Language.English] ?? {}),
    ...(data[language] ?? {}),
  };
}
